module.exports = __webpack_public_path__ + "assets/images/03-active_e740a0a119b20a0e5ad509f43740ee35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-2/03-active.png
// module id = 237
// module chunks = 0